/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable react/jsx-no-constructed-context-values */

import THEMES from 'modules/common/constants/themes';
import React, { useEffect } from 'react';
/**
 * Handle the them change in the application
 */
const initialState = {
  theme: THEMES.DEFAULT,
  setTheme: () => {},
};
//
const ThemeContext = React.createContext(initialState);
/**
 * Handle entire application theme
 * @param {*} param0
 * @returns
 */
const ThemeProvider = ({ children }) => {
  const [theme, _setTheme] = React.useState(initialState.theme);
  //
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme) {
      _setTheme(JSON.parse(storedTheme));
    }
  }, []);
  //
  const setTheme = (_theme) => {
    localStorage.setItem('theme', JSON.stringify(_theme));
    _setTheme(_theme);
  };
  //
  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};
//
export { ThemeProvider, ThemeContext };
